import { render, staticRenderFns } from "./EmailAutoTemplate.vue?vue&type=template&id=af2e65f6&"
import script from "./EmailAutoTemplate.vue?vue&type=script&lang=ts&"
export * from "./EmailAutoTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports